export default "__VITE_ASSET__DGGQqRoW__"